import DialogComponent from "components/Dialog";
import ItemClient from "components/ItemClient";
import SelectClient from "components/SelectClient";

export default class AddFamilyDialog extends DialogComponent {

    constructor(props) {
        super(props);

        this.defaultState = {
            ...this.state,
            items: [],
            client: null,
            relationType: null,
            note: "",
        };

        this.state = { ...this.defaultState };
    }

    title = "client.relative";

    show(info, updateInfo, hideCb) {
        this.info = info;
        this.updateInfo = updateInfo;
        this.hidCb = hideCb;

        if (updateInfo?.client) {
            const { client, note, relationType } = this.updateInfo;

            this.state.client = client;
            this.state.relationType = relationType || null;
            this.state.note = note || "";
        }

        super.show();
    }

    onShow() {
        if (this.state.note)
            this.note.value = this.state.note;
    }

    async save() {
        const { client, relationType, note } = this.state;
        const { relations } = this._config;
        if (!client?.id || !relationType)
            return;

        if (this.info.id === client.id)
            return this.showError("client.cannotHimself", "client.errorAddRelation");

        const relation = relations.find(it => it.id === relationType);


        if (this.info.familyList.includes(client.id))
            return this.showError("Данная связь уже присутствует", "client.errorAddRelation");

        this._helper.showLoading();

        const obj = {
            domainId: this.info.domainId,
            clientFromId: this.info.id,
            clientToId: client.id,
            relationType: relation.relationId,
            status: "PENDING",
            note
        };
        const obj2 = {
            domainId: this.info.domainId,
            clientFromId: client.id,
            clientToId: this.info.id,
            relationType,
            status: "PENDING",
            note
        };

        const updateId = this.updateInfo?.id;
        let resp;
        if (!updateId) {
            resp = await this._request.clientRelations.addn([obj, obj2]);
        } else {
            obj.status = this.updateInfo.status;
            obj2.status = this.updateInfo.status;

            resp = await this._request.clientRelations.updateRalation([obj, obj2]);
        }

        this._helper.hideLoading();

        if (resp?.data) {
            this.hide();

            if (this.hidCb?.apply)
                this.hidCb();
        }
    }

    onClickSelectClient(client) {
        this.setState({ client, relationType: null, note: "" });
    }

    onInputChange(value) {
        this.state.note = value;
    }

    renderContent() {
        const { relations } = this._config;
        const { client, relationType } = this.state;
        const hasClient = !!client;

        let itemsRelation = [];

        if (!this.info.sex) {
            const lastLetter = this.info.fname.charAt(this.info.fname.length - 1);
            let sex = "MALE";
            if (lastLetter === "a" || lastLetter === "я")
                sex = "FEMALE";

            itemsRelation = relations.filter(it => it.sexFrom === sex);

        } else {
            itemsRelation = relations.filter(it => it.sexFrom === this.info.sex);
        }

        let clientSex = null;

        if (client) {
            clientSex = client.sex;
            if (!clientSex) {
                const lastLetter = client.fname.charAt(client.fname.length - 1);
                clientSex = "MALE";
                if (lastLetter === "a" || lastLetter === "я")
                    clientSex = "FEMALE";
            }
        }

        return (
            <div className="content flex col gap16">
                {!hasClient && (
                    <SelectClient
                        className={"bodySelClientDef"}
                        searchShow={true}
                        onClick={this.onClickSelectClient.bind(this)}
                    />
                )}
                {hasClient && (
                    <ItemClient
                        info={client}
                        active={true}
                        removeCb={this.updateInfo ? null : this.changeState.bind(this, "client", null)}
                    />
                )}
                {hasClient && (
                    <div className="blockStatus flex col gap8">
                        {this.insertSelect({
                            value: relationType,
                            label: "client.attitude",
                            showLeftIcon: false,
                            placeHolder: "main.notIndicated",
                            translate: true,
                            /*items: relations,*/
                            items: itemsRelation.filter(it => it.sex === clientSex),
                            onChange: this.changeState.bind(this, "relationType")
                        })}
                    </div>
                )}
                {hasClient && this.insertInput({
                    ref: el => this.note = el,
                    label: "client.note",
                    placeHolder: "client.note",
                    onChange: this.onInputChange.bind(this)
                })}
            </div>
        );
    }
}
